
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class GsButtonGroup extends Vue {
  @Prop({ default: 0 }) activeIndex: number;
  lastButton: any = null;

  @Watch("activeIndex")
  onActiveIndex() {
    const group = this.$refs.group as HTMLDivElement;
    if (!group || !group.children || this.activeIndex < 0) {
      return;
    }

    // 清除上一个按钮的高亮
    if (this.lastButton) {
      this.lastButton.className = this.lastButton.className.replace(
        " active",
        ""
      );
    }

    // 检查索引是否有效
    if (this.activeIndex >= group.children.length) {
      return;
    }

    const targetChild = group.children[this.activeIndex];
    if (!targetChild) {
      return;
    }

    const currentButton = targetChild.getElementsByClassName("group-active-icon")[0];
    if (!currentButton) {
      return;
    }

    (currentButton as any).isActive = true;
    currentButton.className += " active";
    this.lastButton = currentButton;
  }

  // 切换按钮的高亮
  setActiveIndex(e) {
    this.lastButton.className = this.lastButton.className.replace(
      " active",
      ""
    );
    let path = e.path || (e.composedPath && e.composedPath());
    let currentButton = path[0].getElementsByClassName("group-active-icon")[0];
    currentButton.isActive = true;
    currentButton.className += " active";
    this.lastButton = currentButton;
  }

  mouseover() {}

  mouseleave() {}

  mounted() {
    const group = this.$refs.group as HTMLDivElement;
    if (!group) {
      return;
    }

    let children = group.children;
    for (let i = 0; i < children.length; i++) {
      (children[i] as any).index = i;
      (children[i] as HTMLDivElement).addEventListener(
        "setActiveIndex",
        this.setActiveIndex
      );
      // 初始化第一个按钮高亮
      if (i === this.activeIndex) {
        const activeIcon = children[i].getElementsByClassName("group-active-icon")[0];
        if (activeIcon) {
          this.lastButton = activeIcon;
          this.lastButton.className += " active";
        }
      }
    }
  }

  beforeDestroy() {
    let children = (this.$refs.group as HTMLDivElement).children;
    for (let i = 0; i < children.length; i++) {
      (children[i] as HTMLDivElement).removeEventListener(
        "setActiveIndex",
        this.setActiveIndex
      );
    }
  }
}
